<div class="container">
  <div class="row text-center">
    <div class="col-lg-12 col-xl-12 col-sm-12 col-md-12" [ngSwitch]="idioma">
      <ng-container *ngSwitchCase="'2'">
        <h2>Our locations</h2>
      </ng-container>
      <ng-container *ngSwitchCase="'3'">
        <h2>我們的位置</h2>
      </ng-container>
      <ng-container *ngSwitchCase="'4'">
        <h2>Nos emplacements</h2>
      </ng-container>
      <ng-container *ngSwitchCase="'5'">
        <h2>Unsere Standorte</h2>
      </ng-container>
      <ng-container *ngSwitchCase="'6'">
        <h2>Наши локации</h2>
      </ng-container>
      <ng-container *ngSwitchCase="'7'">
        <h2>Nossa sede</h2>
      </ng-container>
      <ng-container *ngSwitchCase="'8'">
        <h2>본사</h2>
      </ng-container>
      <ng-container *ngSwitchDefault>
        <h2>Nuestras sedes</h2>
      </ng-container>
    </div>
    <div class="col-lg-8 col-xl-8 col-sm-12 col-md-12">
      <div class="row">
        <div class="col-lg-12 col-xl-12 col-sm-12 col-md-12 mapM">
          <div id="map" class="map" width="100%">
          </div>
        </div>
      </div>
    </div>
    <div class="col-lg-4 col-xl-4 col-sm-12 col-md-12">
      <div class="row">
        <div class="col-xl-12">
          <div class="sedesContac">
            <div class="row">
              <div class="col-xl-12 col-lg-12 col-md-12 col-12" *ngFor='let data of data[0].default.contactos'>
                <div class="sedeBogota">
                  <a href="{{data.ubicacion}}" class="btn-floating iconoUbicacion"><i class="far fa-map"></i></a>
                  <div>
                    <i class="fas fa-map-marker-alt"></i> {{data.ciudad}}
                  </div>
                  <div>
                    <span>{{data.direccion}}</span>
                  </div>
                  <div>
                    <i class="fas fa-phone" *ngIf='data.t else '></i> {{data.t}}
                  </div>               
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <br>
  <div class="row">
    <div class="col-xl-12">
      <div class="row">
        <div class="titleContac" [ngSwitch]="idioma">
          <ng-container *ngSwitchCase="'2'">
            <h1>{{titulosIn.id}}</h1>
          </ng-container>
          <ng-container *ngSwitchCase="'3'">
            <h1>{{titulosZh.id}}</h1>
          </ng-container>
          <ng-container *ngSwitchCase="'4'">
            <h1>{{titulosFr.id}}</h1>
          </ng-container>
          <ng-container *ngSwitchCase="'5'">
            <h1>{{titulosDe.id}}</h1>
          </ng-container>
          <ng-container *ngSwitchCase="'6'">
            <h1>{{titulosRu.id}}</h1>
          </ng-container>
          <ng-container *ngSwitchCase="'7'">
            <h1>{{titulosBr.id}}</h1>
          </ng-container>
          <ng-container *ngSwitchCase="'8'">
            <h1>{{titulosKr.id}}</h1>
          </ng-container>
          <ng-container *ngSwitchDefault>
            <h1>{{titulos.id}}</h1>
          </ng-container>
        </div>
      </div>

      <div class="row">
        <div class="supportCon col-xl-6 col-lg-6 col-sm-6 col-12" [ngSwitch]="idioma">
          <ng-container *ngSwitchCase="'2'">
            <h2>{{titulosIn.nombre}}</h2>
          </ng-container>
          <ng-container *ngSwitchCase="'3'">
            <h2>{{titulosZh.nombre}}</h2>
          </ng-container>
          <ng-container *ngSwitchCase="'4'">
            <h2>{{titulosFr.nombre}}</h2>
          </ng-container>
          <ng-container *ngSwitchCase="'5'">
            <h2>{{titulosDe.nombre}}</h2>
          </ng-container>
          <ng-container *ngSwitchCase="'6'">
            <h2>{{titulosRu.nombre}}</h2>
          </ng-container>
          <ng-container *ngSwitchCase="'7'">
            <h2>{{titulosBr.nombre}}</h2>
          </ng-container>
          <ng-container *ngSwitchCase="'8'">
            <h2>{{titulosKr.nombre}}</h2>
          </ng-container>
          <ng-container *ngSwitchDefault>
            <h2>{{titulos.nombre}}</h2>
          </ng-container>
          <ul>
            <li>
              <a href="https://wa.me/573132525077" class="btn-floating whatsapp"><i class="fab fa-whatsapp"></i>
              </a>
            </li>
            <li>
               <!-- Enlace a WeChat-->
              <a data-toggle="modal" data-target="#exampleModalCenter1"
                class="btn-floating wechat"><i class="fab fa-weixin"></i>
              </a>
              
              <div class="modal fade" id="exampleModalCenter1" tabindex="-1" role="dialog"
                aria-labelledby="exampleModalCenterTitle" aria-hidden="true">
                <div class="modal-dialog modal-dialog-centered" role="document">
                  <div class="modal-content">
                    <div class="modal-header">
                      <ng-container>
                        <h5 class="modal-title">ID Wechat : supportsatlock</h5>
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close"><span
                            aria-hidden="true">&times;</span></button>                    
                      </ng-container>
                    </div>
                    <div class="modal-body">
                      <div class="col-lg-12 col-md-12 col-sm-12 col-xl-12">
                        <div class="row d-flex justify-content-between align-self-center contenTB">
                          <div class="col-lg-12 col-xl-12 col-md-12 col-sm-12 col-12">
                            <a><img src="assets/img/QRWeChatSatlock.jpeg"></a>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>                       
            </li>
          </ul>
        </div>
        <div class="redesContac col-xl-6 col-lg-6 col-sm-6 col-12">
          <div class="btn-redes" [ngSwitch]="idioma">
            <ng-container *ngSwitchCase="'2'">
              <h2>{{titulosIn.descripcion}}</h2>
            </ng-container>
            <ng-container *ngSwitchCase="'3'">
              <h2>{{titulosZh.descripcion}}</h2>
            </ng-container>
            <ng-container *ngSwitchCase="'4'">
              <h2>{{titulosFr.descripcion}}</h2>
            </ng-container>
            <ng-container *ngSwitchCase="'5'">
              <h2>{{titulosDe.descripcion}}</h2>
            </ng-container>
            <ng-container *ngSwitchCase="'6'">
              <h2>{{titulosRu.descripcion}}</h2>
            </ng-container>
            <ng-container *ngSwitchCase="'7'">
              <h2>{{titulosBr.descripcion}}</h2>
            </ng-container>
            <ng-container *ngSwitchCase="'8'">
              <h2>{{titulosKr.descripcion}}</h2>
            </ng-container>
            <ng-container *ngSwitchDefault>
              <h2>{{titulos.descripcion}}</h2>
            </ng-container>
            <ul>
              <li>
                <a href="https://www.facebook.com/pg/satlockcolombia/posts/" class="facebook btn-floating"> <i
                    class="fab fa-facebook-f"></i> </a>
              </li>
              <li>
                <a href="https://twitter.com/satlockcolombia?lang=es" class="twitter btn-floating"> <i
                    class="fab fa-twitter"></i> </a>
              </li>
              <li>
                <a href="https://www.youtube.com/channel/UCM20iHXnuOdwwTE9Al3RWOg" class="youtube btn-floating"> <i
                    class="fab fa-youtube"></i> </a>
              </li>
              <li>
                <a href="https://co.linkedin.com/company/satlock" class="linkedin btn-floating"> <i
                    class="fab fa-linkedin-in"></i> </a>
              </li>
            </ul>
          </div>
        </div>
      </div>
      <div class="disponibleAp" [ngSwitch]="idioma">
        <ng-container *ngSwitchCase="'2'">
          <h2>{{titulosIn.imagen}}</h2>
        </ng-container>
        <ng-container *ngSwitchCase="'3'">
          <h2>{{titulosZh.imagen}}</h2>
        </ng-container>
        <ng-container *ngSwitchCase="'4'">
          <h2>{{titulosFr.imagen}}</h2>
        </ng-container>
        <ng-container *ngSwitchCase="'5'">
          <h2>{{titulosDe.imagen}}</h2>
        </ng-container>
        <ng-container *ngSwitchCase="'6'">
          <h2>{{titulosRu.imagen}}</h2>
        </ng-container>
        <ng-container *ngSwitchCase="'7'">
          <h2>{{titulosBr.imagen}}</h2>
        </ng-container>
        <ng-container *ngSwitchCase="'8'">
          <h2>{{titulosKr.imagen}}</h2>
        </ng-container>
        <ng-container *ngSwitchDefault>
          <h2>{{titulos.imagen}}</h2>
        </ng-container>


      </div>
      <div class="row">

        <div class="col-xl-6 col-lg-6 col-sm-12 col-12">
          <a href="https://play.google.com/store/apps/details?id=com.satlock.d2d&hl=es">
            <img class="playStore" src="./assets/img/playStore.png" alt="">
          </a>
        </div>
        <div class="col-xl-6 col-lg-6 col-sm-12  col-12">
          <a href="https://apps.apple.com/co/app/satlock-d2d/id1469247870">
            <img class="appStore" src="./assets/img/AppStore.png" alt="">
          </a>
        </div>
      </div>
      <!-- <div class="row">
        <div class="col-xl-12">
          <div class="sedesContac">
            <div class="row">

              <div class="col-xl-4 col-lg-4 col-md-4 col-12" *ngFor='let data of data[0].default.contactos'>
                <div class="sedeBogota">
                  <a href="{{data.ubicacion}}" class="btn-floating iconoUbicacion"><i class="far fa-map"></i></a>
                  <div>
                    <i class="fas fa-map-marker-alt"></i> {{data.ciudad}}
                  </div>
                  <div>
                    <span>{{data.direccion}}</span>
                  </div>
                  <div>
                    <i class="fas fa-phone" *ngIf='data.t else '></i> {{data.t}}
                  </div>
                  <div>
                    {{data.Tel}}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div> -->
    </div>
  </div>
</div>